import type {JSX} from 'react'
import {useParams} from 'react-router-dom'
import {useClientPermission} from '../hooks/permission.hooks'
import {EPermission, EResource} from '../types/permission.type'
import Loader from '../components/Loader'
import Error403 from './Error403'

interface PermissionRouteProps {
  children: JSX.Element
  resource: EResource
  permission?: EPermission
}

export default function PermissionRoute({
  children,
  resource,
  permission = EPermission.CAN_VIEW,
}: PermissionRouteProps) {
  const {clientId} = useParams()
  const {can, isLoading} = useClientPermission(clientId)

  // Show loading state while checking permissions
  if (isLoading) {
    return <Loader variant='fullscreen' />
  }

  // Check if user has the required permission
  if (!can(permission, resource)) {
    // Show 403 Forbidden page if user doesn't have permission
    return <Error403 />
  }

  return children
}
